import AntDesign from '@expo/vector-icons/AntDesign';
import { useCallback, useRef, useState } from 'react';
import { Dimensions, StyleSheet, TextInput, View } from 'react-native';
import { Text } from '@/components/Text';
import { Dropdown } from 'react-native-element-dropdown';
import { capitalizeWords } from '@/utils/capitalize';
import colors from '@/config/colors';
import { useTextsetContext } from '@/hooks/useTextsetContext';
import { styles } from './styles';
import { PressableNeolexon } from '@/components/PressableNeolexon';
import RadioButton from '@/components/ui/therapist/RadioButton';
const width = Dimensions.get('window').width;

const innerStyles = StyleSheet.create({
  input: {
    borderColor: 'gray',
    borderRadius: 1,
    borderWidth: 1,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  textInput: {
    width: Dimensions.get('window').width / 3,
    height: 30,
    padding: 5,
    fontSize: 20,
    color: colors.newUI.therapist.textBlue100,
  },
  closeButtonParent: {
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 5,
  },
  radioContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    marginLeft: 3,
  },
  marginRight: {
    marginRight: 7.5,
  },
  dropDownContainer: {
    position: 'relative',
    zIndex: 1,
  },
  dropdown: {
    minWidth: width < 800 ? 250 : 400,
    height: 50,
    borderColor: 'gray',
    borderWidth: 0.5,
    borderRadius: 8,
    paddingHorizontal: 4,
  },
  placeholderStyle: {
    fontSize: 16,
    color: colors.newUI.therapist.grey70,
  },
  selectedTextStyle: {
    fontSize: 14,
    color: colors.newUI.therapist.textBlue100,
  },
  iconStyle: {
    width: 20,
    height: 20,
  },
  inputSearchStyle: {
    height: 40,
    fontSize: 16,
    color: colors.newUI.therapist.textBlue100,
  },
  blueBorder: { borderColor: 'blue' },
});

const termTypes = [
  {
    name: 'Textsuche',
    value: 'text',
  },
  {
    name: 'Kategoriesuche',
    value: 'tag',
  },
];

export function SecondHeader() {
  const { term, termType, changeOuterState, tags } = useTextsetContext();
  const inputRef = useRef(null);
  const data = tags.map((tag) => {
    return {
      label: capitalizeWords(tag),
      value: tag,
    };
  });
  const [isFocus, setIsFocus] = useState(false);
  const placeholder = termType == 'text' ? 'Textsuche' : 'Kategoriesuche';

  const handleTermChange = useCallback((value) => {
    changeOuterState('term', capitalizeWords(value));
  }, []);

  const handleTermClear = useCallback(() => {
    handleTermChange('');
    inputRef.current?.clear();
  }, []);

  const handleTermTypeChange = useCallback((name, value) => {
    return () => {
      changeOuterState(name, value);
    };
  }, []);

  return (
    <View style={styles.secondHeader}>
      <Text style={[innerStyles.marginRight, styles.secondHeaderTitle]}>
        Texte suchen
      </Text>
      {termType == 'text' ? (
        <View style={[innerStyles.input, innerStyles.marginRight]}>
          <TextInput
            ref={inputRef}
            defaultValue={term}
            placeholder={placeholder}
            placeholderTextColor={colors.newUI.therapist.grey70}
            style={innerStyles.textInput}
            allowFontScaling={false}
            onChangeText={handleTermChange}
          />
          <PressableNeolexon
            onPress={handleTermClear}
            style={innerStyles.closeButtonParent}
          >
            <AntDesign name="close" size={24} color={colors.darkGrey} />
          </PressableNeolexon>
        </View>
      ) : (
        <View style={innerStyles.dropDownContainer}>
          <Dropdown
            style={[innerStyles.dropdown, isFocus && innerStyles.blueBorder]}
            placeholderStyle={innerStyles.placeholderStyle}
            selectedTextStyle={innerStyles.selectedTextStyle}
            inputSearchStyle={innerStyles.inputSearchStyle}
            itemTextStyle={{ color: colors.newUI.therapist.textBlue100 }}
            iconStyle={innerStyles.iconStyle}
            data={data}
            search
            mode={'auto'}
            placeholder={!term ? 'Kategorie auswählen' : term}
            searchPlaceholder="Kategoriesuche"
            value={term}
            labelField="label"
            valueField="value"
            onFocus={() => setIsFocus(true)}
            onBlur={() => setIsFocus(false)}
            onChange={(item) => {
              handleTermChange(item.value);
              setIsFocus(false);
            }}
          />
        </View>
      )}
      <View style={innerStyles.radioContainer}>
        {termTypes.map((eachTermType) => {
          return (
            <View key={eachTermType.name} style={{ marginHorizontal: 16 }}>
              <RadioButton
                onPress={handleTermTypeChange('termType', eachTermType.value)}
                label={eachTermType.name}
                isSelected={termType === eachTermType.value}
                labelStyle={{ fontWeight: '600' }}
              />
            </View>
          );
        })}
      </View>
    </View>
  );
}
